import { useTheme } from "@mui/material";
import { useLocation, useParams } from "react-router-dom";
import { ActivityKeys } from "web_myplann/Api/Activities/ActivityKeys";
import { TaskKeys } from "web_myplann/Api/Tasks/TaskKeys";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { DetailLoader } from "web_myplann/Portfolio/Components/Redesign/Detail/DetailLoader";
import { ContactHeaderActions } from "web_myplann/Shared/Components/ContactHeaderActions";
import { MyPlannLayout } from "web_myplann/Shared/Header/MyPlannLayout";
import { MyPlannNavigationHeader } from "web_myplann/Shared/Header/MyPlannNavigationHeader";
import { useNotFoundRedirect } from "web_myplann/Shared/Hooks/useNotFoundRedirect";
import { getBackFallbackRoute } from "web_myplann/Shared/Utils/backNavigation";
import { getTypedParam } from "web_myplann/Shared/Utils/getTypedParam";
import { TaskBasicInfoSection } from "web_myplann/Tasks/Components/TaskBasicInfoSection";
import { TaskProcessSection } from "web_myplann/Tasks/Components/TaskProcessSection";
import { useTaskDetail } from "web_myplann/Tasks/Hooks/useTaskDetail";

const R = Resources.Task.Detail;

export const TaskDetailV2Page = () => {
	const routeParams = useParams<{ id: string }>();
	const taskId = getTypedParam(routeParams, "id", Number) ?? null;
	const theme = useTheme();
	const { t } = useResource();
	const location = useLocation();

	const { task, phases, isLoading, isNotFound, contact } =
		useTaskDetail(taskId);
	useNotFoundRedirect({
		isNotFound,
		message: t(R.notFoundToast),
		defaultRoute: Routing.ActivitiesList.path(),
		invalidateQueryKeys: [TaskKeys.lists(), ActivityKeys.events()],
	});

	return (
		<MyPlannLayout
			disableContentPadding
			bgColor={theme.palette.surface.muted}
			topBar={
				<MyPlannNavigationHeader
					title={t(R.title)}
					bgColor={theme.palette.background.paper}
					defaultRoute={getBackFallbackRoute(location.pathname)}
					replaceOnBack
					endComponent={<ContactHeaderActions contact={contact} />}
				/>
			}
		>
			{isLoading && <DetailLoader />}
			{!isLoading && task && (
				<>
					<TaskBasicInfoSection task={task} />
					{phases.length > 0 && <TaskProcessSection phases={phases} />}
				</>
			)}
		</MyPlannLayout>
	);
};
